/* unplugin-vue-components disabled */import script from "./LectureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LectureCard.vue?vue&type=script&setup=true&lang=js"

import "./LectureCard.vue?vue&type=style&index=0&id=0e9dfd21&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9dfd21"]])

export default __exports__